import { ContactData as ContactDataType } from "../../../sanity/lib/queries/getNavigationData";

export const ContactData = ({ contactData }: { contactData: ContactDataType }) => {
    return (
        <div className="flex flex-col gap-3 xl:gap-4">
            <div>
                <a
                    href={`mailto:${contactData?.email.emailAddress}`}
                    className="hover:no-underline m-link-l xl:d-link-l"
                >
                    {contactData?.email.label}
                </a>
            </div>
            <div>
                <a
                    href={`tel:${contactData?.phone.phoneNumber}`}
                    className="hover:no-underline m-link-l xl:d-link-l"
                >
                    {contactData?.phone.label}
                </a>
            </div>
        </div>
    );
};
